import { render, staticRenderFns } from "./SkeletonTemplate.vue?vue&type=template&id=f4abb456&"
import script from "./SkeletonTemplate.vue?vue&type=script&lang=ts&"
export * from "./SkeletonTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports